import { CONDITION_TYPE, ISearchParam } from '../../intelligentCourseList/interface/pageData';
import { PAY_METHOD } from 'market/@marketCommon/interface/base';
import { lang, isSystem } from '@umu/ukit-lang';
import { ENTERPRISE_ROLE } from '@umu/umu-types';
import { services } from 'common';
const { getModuleData } = services;

export const LABEL_TYPE_NAME: Record<CONDITION_TYPE, keyof ISearchParam> = {
    [CONDITION_TYPE.POSITION]: 'job_label_id',
    [CONDITION_TYPE.STAGE]: 'job_level_label_id',
    [CONDITION_TYPE.SCENE]: 'applicable_scenario_label_id',
};

export const PAY_METHOD_UNIT: Record<PAY_METHOD, string> = {
    [PAY_METHOD.BY_YEAR]: lang('/年'),
    [PAY_METHOD.BY_NOTHING]: '',
    [PAY_METHOD.BY_USER]: lang('/账户'),
    [PAY_METHOD.BY_PACKAGE]: '',
};

export const isAdmin = () => {
    return getModuleData('userInfo', 'enterprise_info', 'role_type') === ENTERPRISE_ROLE.ADMIN;
};

export const supportIntelligentCourse = isAdmin() && isSystem('CN');
export const supportUMUAndNewTag = isSystem('CN');

export const openIntelligentList = () => {
    window.open('/market/intelligent-course-list');
};
